<template>
    <div class="myClassCourseDialog">
        <!-- <el-dialog :title="myTitle" width="50%"  :visible.sync="dialogVisible" :close-on-click-modal="false">
            <el-form :model="myClassCourseForm" ref="myClassCourseDialogForm" :rules="myClassCourseRules" label-suffix=":">
                <el-form-item label="班级"  prop="courseId" :label-width="formLabelWidth">
                    <el-select v-model="myClassCourseForm.hardClassId" filterable placeholder="请选择" remote :remote-method="remoteHardClass" style="width: 100%">
                        <el-option v-for="item in hardClassList" :key="item.id" :label="item.name+'('+item.year+')'" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属课程"  prop="courseId" :label-width="formLabelWidth">
                    <el-select v-model="myClassCourseForm.courseId" filterable placeholder="请选择" remote :remote-method="remoteCourse" style="width: 100%">
                        <el-option v-for="item in courseList" :key="item.id" :label="item.name+'('+item.course_no+')'" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog> -->

        <el-dialog  :title="myTitle" fullscreen  :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancel">

            <el-form :model="myClassCourseForm" ref="myClassCourseDialogForm" :rules="myClassCourseRules" label-suffix=":" :inline="true" >
                <el-form-item label="绑定课程"  prop="courseId" :label-width="formLabelWidth">
                    <el-select v-model="myClassCourseForm.courseId" filterable placeholder="请输入关键字或下拉选择"   :filter-method="handleFilterCourse"  >
                        <el-option v-for="item in courseList" :key="item.id" :label="item.name+'('+item.course_no+')'" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-button type="primary" @click="loadCourseList"> 查 询 </el-button> -->
                    <span style="margin-left: 10px">
                        说明： 与考试所选课程一致
                    </span>
                </el-form-item>
            </el-form>

            

            <!-- <span style="margin: 25px" > 搜索</span> -->
            <el-form :model="searchForm" :inline="true" style="margin-top: 20PX">

                <el-form-item label="入学学年"  prop="acadyearTerm" :label-width="formLabelWidth">
                    <el-select v-model="searchForm.acadyearTerm" filterable placeholder="请输入关键字或下拉选择">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in acadyearTermList" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <!-- <el-form-item label="搜索" :label-width="formLabelWidth" /> -->
                <el-form-item label="专业"  prop="professionId" :label-width="formLabelWidth">
                    <el-select v-model="searchForm.professionId" filterable placeholder="请输入关键字或下拉选择"  :filter-method="handleFilterProfession"  >
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in professionList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级名称"  prop="name" :label-width="formLabelWidth">
                    <el-input  v-model="searchForm.name" placeholder="请输入班级名称" ></el-input>
                </el-form-item>

               

                <el-button type="primary" @click="loadHardClassList"> 查 询 </el-button>
            </el-form>
            

            <!-- <div style="text-align: center;margin-top: 20px;" class="transfer-wrapper"> 
                <el-transfer
                    style="text-align: left; display: inline-block;"
                    v-model="chooseHardClassList"
                    filterable
                    :titles="['待选行政班', '已选行政班']"
                    :format="{
                        noChecked: '${total}',
                        hasChecked: '${checked}/${total}'
                    }"
                    @change="handleChange"
                    :data="hardClassTypeList"
                    >
                    <span slot-scope="{ option }">{{ option.label }}({{ option.year }})</span>
                </el-transfer>
            </div> -->



            <el-row style="margin-top: 20px;">
                <el-col :span="11">
                    <el-table v-loading="loading" :data="hardClassTypeList" height="400" style="width: 100%" align='center'>
                        <el-table-column prop="name" label="名称"   align='center' ></el-table-column>
                        <el-table-column prop="year" label="入学年" align='center' width="150"></el-table-column>
                        <el-table-column prop="operation" align='center' label="操作" >
                            <template slot-scope='scope'>
                                <el-button icon='edit' size="mini" @click='addHardClassList(scope.row)'>加入</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
                </el-col>
                <el-col :span="2">
                    <el-button icon='edit' size="mini" type="danger" @click='deleteHardClassListAll()'>全部移除</el-button>
                </el-col>
                <el-col :span="11">
                    <el-table v-loading="loading" :data="chooseHardClassList" height="400" style="width: 100%" align='center'>
                        <el-table-column prop="name" label="名称"   align='center' ></el-table-column>
                        <el-table-column prop="year" label="入学年" align='center' width="150"></el-table-column>
                        <el-table-column prop="operation" align='center' label="操作">
                            <template slot-scope='scope'>
                                <el-button icon='edit' size="mini" type="danger" @click='deleteHardClassList(scope.row)'>移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>


            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="submitFormBatch">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from "@/components/pagination";
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    

    export default {
        name: 'myClassCourseDialog',
        data(){
            return {
                formLabelWidth: '120px', myTitle: null,
                dialogVisible:false, loading: false,
                courseList: [], courseForm: {id: null, searchText: null},
                hardClassList: [], hardClassForm: {id: null, searchText: null},
                myClassCourseForm:{ 
                    id: null, 
                    teacherId: null, 
                    hardClassId: null, 
                    courseId: null,  
                    schoolId: null,
                    semester: null,
                    profession: null
                },
                myClassCourseRules: {
                    hardClassId: [{ required: true, message: '请选择班级', trigger: 'blur' }],
                    courseId: [{ required: true, message: '请选择课程', trigger: 'blur' }],
                    
                },
                searchForm:{
                    pageNo: 1, 
                    pageSize: 50, 
                    totalCount: 50,
                    professionId:null,
                    acadyearTerm:null,
                    name: null
                },
                schoolList: [],
                acadyearTermList: [],
                professionList: [],
                hardClassTypeList:[],
                // 选中行政班备用
                chooseSpare:[],
                // 选中行政班
                chooseHardClassList:[],
                // 专业列表
                professionList:[],
                searchKeyword: null, // 存储输入的关键字
                searchKeyProfession: null,
                // 多选列表
                multipleSelection: [],

            }
        },
        components:{
            Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
        },
      	mounted() {
            this.loadCourseList();
            this.loadHardClassList();
            this.loadSchoolList()
            this.loadAcadyearTermList()
            this.loadProfessionList()
	    },
        props: {
            myClassCourse: {
                type: Object
            }
        },
        watch: {
            myClassCourse: {
                deep: true, immediate:true,
                handler(n, o){
                    this.hardClassForm.id = null; this.hardClassForm.searchText = null;
                    this.courseForm.id = null; this.courseForm.searchText = null;
                }
            },
        },
        methods: {
            showDialog(){
                this.dialogVisible = true;
            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                this.searchForm = {
                    pageNo: 1, 
                    pageSize: 50, 
                    totalCount: 0,
                    professionId:null,
                    acadyearTerm:null,
                    name: null
                },
                this.myClassCourseForm = { 
                    id: null, 
                    teacherId: null, 
                    hardClassId: null, 
                    courseId: null,  
                    schoolId: null,
                    semester: null,
                    profession: null
                },
                this.chooseHardClassList = []
                this.dialogVisible = false;
                this.$emit('cancel');
            },
            remoteCourse(query){
                if(query !== ''){
                    this.courseForm.id = null;
                    this.courseForm.searchText = query;
                    this.courseList = [];
                    this.loadCourseList();
                }
            },
            loadCourseList(){
                let search = { licenceId: this.userInfo.licenceId, //schoolId: this.userInfo.schoolId,
                    // id: mUtils.searchText(this.courseForm.id),  searchText: mUtils.searchText(this.courseForm.searchText)};
                    id: mUtils.searchText(this.courseForm.id),  searchText: mUtils.searchText(this.searchKeyword)};
                let param = { controllerName: 'sclCource', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.courseList = data.result;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            loadProfessionList(){
                let search = { licenceId: this.userInfo.licenceId,searchText: mUtils.searchText(this.searchKeyProfession)};
                let param = { controllerName: 'sclProfession', methodName: '/list', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.professionList = data.result;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            remoteHardClass(query){
                if(query !== ''){
                    this.hardClassForm.id = null;
                    this.hardClassForm.searchText = query;
                    this.hardClassList = [];
                    this.loadHardClassList();
                }
            },
            loadHardClassList(){
                let search = {  
                    licenceId: this.userInfo.licenceId,
                    professionId: mUtils.searchText(this.searchForm.professionId) ,
                    year: mUtils.searchText(this.searchForm.acadyearTerm),
                    searchText:mUtils.searchText(this.searchForm.name),
                };
                // let param = { controllerName: 'sclHardClass', methodName: '/list', pageNo: 1, pageSize: 50, param: search};
                // let search = { id: mUtils.searchText(this.hardClassForm.id),  searchText: mUtils.searchText(this.hardClassForm.searchText), licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'sclHardClass', methodName: '/list', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        // let result = data.result
                        // result.forEach(element => {
                        //     element.isCheck = false
                        // });
                        this.hardClassTypeList = data.result
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            loadSchoolList(callback){

                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'school', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.schoolList = data.result;
                        this.searchForm.schoolId = this.userInfo.schoolId;
                        if(callback) callback();
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            loadAcadyearTermList(){
                this.acadyearTermList = [];
                let now = new Date();
                let year = parseInt(now.getFullYear());
                for(let i=(year-3); i<(year+2); i++){
                    this.acadyearTermList.unshift((i-1));
                   
                }
            },
            submitForm(){
                console.log(this.myClassCourseForm);
                let that = this;
                this.$refs.myClassCourseDialogForm.validate((valid) => {
                    if(valid){
                        this.loading = true;
                        this.myClassCourseForm.teacherId = this.userInfo.id;
                        let param = { controllerName: 'teacherMyClass/', methodName: 'addHardCourse', param: this.myClassCourseForm};
                        simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                            console.log('myClassCourse', code);
                            if (code == 0) {
                                this.dialogVisible = false;
                                that.$emit('ok');
                            }else{
                                that.$message({ type: 'error', message: '您已是授课老师'});
                            }
                            this.loading = false;
                        }).catch((error) => {
                            this.loading = false;
                        });
                    }
                });
            },
            submitFormBatch(){
                // 先判断是否已经选择了行政班
                if(this.chooseHardClassList.length == 0){
                    this.$message.warning("请选择行政班后再提交保存")
                    return;
                }
                this.$refs.myClassCourseDialogForm.validate((valid) => {
                    if(valid){
                        this.loading = true;
                        this.myClassCourseForm.teacherId = this.userInfo.id;
                        let info = {
                            teacherId: this.userInfo.id,
                            courseId:this.myClassCourseForm.courseId,
                            hardList: this.chooseHardClassList
                        }
                        let param = { controllerName: 'teacherMyClass/', methodName: 'addHardCourseBatch', param: info};
                        simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                            console.log('myClassCourse', code);
                            if (code == 0) {
                                this.$emit('ok');
                                this.dialogVisible = false;
                                this.$message.success("行政班添加成功！")
                            }
                            this.loading = false;
                        }).catch((error) => {
                            this.loading = false;
                        });
                    }
                })
            },
            loadHardClassTypeList(){
                let search = {  
                    licenceId: this.userInfo.licenceId,
                    professionId: mUtils.searchText(this.searchForm.professionId) ,
                    year: mUtils.searchText(this.searchForm.acadyearTerm),
                    name:mUtils.searchText(this.searchForm.name),
                };
                let param = { controllerName: 'sclHardClass', methodName: '/list', pageNo: 1, pageSize: 50, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        // 过滤行政班格式
                        this.hardClassTypeList = data.result;
                        // let hardClassTypeList = []
                        // 备份选中
                        // this.chooseSpare = [...this.chooseHardClassList]
                        // let chooseSpare = [...this.chooseHardClassList]
                        // data.result.forEach(element => {
                        //     element.key = element.id
                        //     element.label = element.name
                        //     hardClassTypeList.push(element)
                        // });
                        // this.hardClassTypeList = hardClassTypeList
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            // 输入关键字时触发，val就是输入的文本
            handleFilterCourse(val) {
                this.searchKeyword = val // 把输入值存到变量里
                // console.log('你输入的关键字：', this.searchKeyword)
                this.loadCourseList()
            },
            // 输入关键字时触发，val就是输入的文本
            handleFilterProfession(val) {
                this.searchKeyProfession = val 
                this.loadProfessionList()
            },
            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadHardClassList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadHardClassList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 添加
            addHardClassList(row){
                // 判断已选列表是否存在，已存在则不添加
                let id = row.id
                let exists = this.chooseHardClassList.some(item => item.id === id)
                if(exists){
                    this.$message({ type: 'warning', message: '该行政班已存在，请勿重复添加'});
                    return
                }
                this.chooseHardClassList.push(row)
            },
            deleteHardClassList(row){
                let id = row.id
                let index = this.chooseHardClassList.findIndex(item => item.id === id)
                this.chooseHardClassList.splice(index, 1)
            },
            deleteHardClassListAll(){
                this.chooseHardClassList = []
            }

        },
    }
</script>

<style scoped>

    .myClassCourseDialog{

    }

    /* .transfer-wrapper >>> .el-transfer-panel {
        width :350px;
        height: 500px
    } */

    /* 完整的高度设置方案 */
    .transfer-wrapper >>> .el-transfer {
    height: 500px;  /* 1. 设置transfer总高度 */
    }

    .transfer-wrapper >>> .el-transfer-panel {
    width: 350px;
    height:  500px;  /* 2. 设置面板高度 */
    }

    .transfer-wrapper >>> .el-transfer-panel__body {
    height: calc(100% - 40px);  /* 3. 设置body高度（减去header） */
    }

    .transfer-wrapper >>> .el-transfer-panel__list {
    height: 100%;  /* 4. 关键！设置列表区域高度 */
    }
    .pagination{
        text-align: left;
        margin-top: 10px;
    }


    

</style>


